module.exports = require("xml");


//////////////////
// WEBPACK FOOTER
// external "xml"
// module id = 608
// module chunks = 0